<button style="display: none;"></button>
<div class="grid  header-idfx">
  @for (filter of filters; track $index) {
  <div class="col-4">
    <div class="mb-3 pl-3">
      <b>{{ filter.header }}</b>
    </div>
    <div>
      @if (filter.type == 'select') {
      <p-scrollPanel [style]="{ height: '170px', background: 'white' }">
        <p-tree
          [filter]="filter.search"
          styleClass="noChildren"
          [style]="{ height: '100%' }"
          [value]="filter.values"
          selectionMode="checkbox"
          [(selection)]="values[filter.name]"
          (selectionChange)="outlined=false"
        />
      </p-scrollPanel>
      }@else if (filter.type == 'slider') {
      <div class="w-8 p-3">
        <p-slider
          [(ngModel)]="values[filter.name]"
          [range]="true"
          (ngModelChange)="outlined=false"
        />
        <div class="mt-4">
          <div class="flex">
            <div class="flex-auto grid">
              <div class="col-4 flex align-items-center">Min:</div>
              <div class="col-8">
                <div style="max-width: 50px">
                  <p-inputNumber
                    class="w-full"
                    ngDefaultControl
                    [(ngModel)]="values[filter.name][0]"
                    (ngModelChange)="updateRange(filter.name); outlined=false"
                    (focusout)="verifyRange(filter.name)"
                  />
                </div>
              </div>
            </div>
            <div class="flex-auto grid">
              <div class="col-4 flex align-items-center">Max:</div>
              <div class="col-8" style="text-align: right">
                <div style="max-width: 50px">
                  <p-inputNumber
                    class="w-full"
                    ngDefaultControl
                    [(ngModel)]="values[filter.name][1]"
                    (ngModelChange)="updateRange(filter.name); outlined=false"
                    (focusout)="verifyRange(filter.name)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }@else if (filter.type == 'date') {
      <div class="p-3">
        <div>
          <p-datepicker
            appendTo="body"
            [showIcon]="true"
            placeholder="Entrer une date"
            [(ngModel)]="values[filter.name]"
            (ngModelChange)="outlined=false"
            selectionMode="range"
            dateFormat="dd/MM/yyyy HH:mm"
            [readonlyInput]="true"
          />
        </div>
        <div>
          <div>
            <div class="block pt-3">
              <p-radioButton
                name="calendar"
                value="day"
                inputId="day"
                [(ngModel)]="since"
                (ngModelChange)="updateDateValues(filter.name); outlined=false"
              />
              <label for="day" class="ml-2"> Depuis hier </label>
            </div>
            <div class="block pt-3">
              <p-radioButton
                name="calendar"
                value="week"
                inputId="week"
                [(ngModel)]="since"
                (ngModelChange)="updateDateValues(filter.name); outlined=false"
              />
              <label for="week" class="ml-2"> Depuis une semaine </label>
            </div>
            <div class="block pt-3">
              <p-radioButton
                name="calendar"
                value="month"
                inputId="month"
                [(ngModel)]="since"
                (ngModelChange)="updateDateValues(filter.name); outlined=false"
              />
              <label for="day-30" class="ml-2"> Depuis 1 mois </label>
            </div>
            <div class="block pt-3">
              <p-radioButton
                name="calendar"
                value="year"
                inputId="year"
                [(ngModel)]="since"
                (ngModelChange)="updateDateValues(filter.name); outlined=false"
              />
              <label for="year" class="ml-2"> Depuis 1 an </label>
            </div>
          </div>
        </div>
      </div>
      }@else if (filter.type == "dateTime") {
        <div class="p-3">
          <div>
            <p-datepicker
              appendTo="body"
              [showIcon]="true"
              [placeholder]="'filters.enterStartDate' | translate"
              [(ngModel)]="values[filter.name][0]"
              dateFormat="dd/mm/yy"
              (ngModelChange)="dateChange('start', values[filter.name][0])"
              [readonlyInput]="true"
              [showTime]="true"
              [showButtonBar]="true"
              [maxDate]="maxDate" />
            <div class="h-1rem"></div>
            <p-datepicker
              appendTo="body"
              [showIcon]="true"
              [placeholder]="'filters.enterEndDate' | translate"
              [(ngModel)]="values[filter.name][1]"
              dateFormat="dd/mm/yy"
              (ngModelChange)="dateChange('end', values[filter.name][1])"
              [readonlyInput]="true"
              [showTime]="true"
              [showButtonBar]="true"
              [minDate]="minDate" />
          </div>
          <div>
            <div>
              <div class="block pt-3">
                <p-radioButton
                  name="calendar"
                  value="day"
                  inputId="day"
                  [(ngModel)]="since"
                  (ngModelChange)="updateDateValues(filter.name); outlined = false" />
                <label for="day" class="ml-2">  {{ "filters.fromYesterday" | translate }} </label>
              </div>
              <div class="block pt-3">
                <p-radioButton
                  name="calendar"
                  value="week"
                  inputId="week"
                  [(ngModel)]="since"
                  (ngModelChange)="updateDateValues(filter.name); outlined = false" />
                <label for="week" class="ml-2">  {{ "filters.fromWeek" | translate }} </label>
              </div>
              <div class="block pt-3">
                <p-radioButton
                  name="calendar"
                  value="month"
                  inputId="month"
                  [(ngModel)]="since"
                  (ngModelChange)="updateDateValues(filter.name); outlined = false" />
                <label for="day-30" class="ml-2">  {{ "filters.fromMonth" | translate }} </label>
              </div>
              <div class="block pt-3">
                <p-radioButton
                  name="calendar"
                  value="year"
                  inputId="year"
                  [(ngModel)]="since"
                  (ngModelChange)="updateDateValues(filter.name); outlined = false" />
                <label for="year" class="ml-2"> {{ "filters.fromYear" | translate }} </label>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  }
</div>

<div class="footer-idfx">
  <p-button
    type="button"
    [label]="'buttons.validate'| translate"
    icon="pi pi-check-square"
    [outlined]="outlined"
    (click)="closeModal()"
  />
</div>
